import { DataType } from "ka-table"
import { ActionButton } from "../../components/buttons/actionButtons";
import { DELETE, UPDATE } from "../../constant/commonConst";
import { confirmBox } from "../../components/toast";
import { TableColumn } from "../../components/table/table";

export const columns = (actions: any): TableColumn[] => {
    return [
        {
            key: 'id',
            title: 'id',
            dataType: DataType.Number,
            visible: false
        },
        {
            key: 'name',
            title: 'Name',
            dataType: DataType.String
        },
        {
            key: 'userName',
            title: 'Username',
            dataType: DataType.String
        },
        {
            key: 'emailId',
            title: 'Email Address',
            dataType: DataType.String
        },
        {
            key: 'mobileNo',
            title: 'Mobile No.',
            dataType: DataType.String
        },

        // {
        //     key: 'isDeactivated',
        //     title: 'status',
        //     // hideHeaderFilter: false,
        //     dataType: DataType.String
        // },
        {
            key: 'edit',
            title: '',
            hideHeaderFilter: false,
            component: ActionButton,
            callBack: async (row) => {
                if (row.status === UPDATE) {
                    actions.openAddEditFrom({
                        id: row.data.id,
                        name: row.data.name,
                        emailId: row.data.emailId,
                        mobileNo: row.data.mobileNo,
                        isDeactivated: false,
                        roleId: row.data.roleId,
                        password: row.data.password,
                        userName:row?.data?.userName,
                        isUpdate:true,
                      })
                } else if (row.status === DELETE) {
                    const response = await confirmBox("you want to delete this user?");
                    if (response) {
                        actions.api.removeValue(row.data.id);
                    }
                }
            },
            style: {
                textAlign: 'center',
            }
        },
    ]
}
